import React, {useEffect, useState} from "react";
import {
    Alert,
    Breadcrumb,
    Button,
    Input,
    Layout,
    message,
    Skeleton,
    Space,
    Table,
    Tabs,
    Tag,
    Form
} from 'antd';
import {Link} from "react-router-dom";
import Api from "../api";
import {EditOutlined} from '@ant-design/icons';
import {redirect} from "../helpers";
import moment from "moment";

const {TabPane} = Tabs;
const {Content} = Layout;
const {TextArea} = Input;

const NotificationsView = ({onClickEvent}) => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [form] = Form.useForm();

    useEffect(() => {
        loadNotifications();
    }, []);

    const loadNotifications = () => {
        Api.get('/admin/notifications').then(response => {
            setNotifications(response.data.data);
            setLoading(false);
        });
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: '8%',
            render: (value, record) => record.id,
        },
        {
            title: 'Type',
            dataIndex: 'type',
            render: (label, record) => record?.type,
            width: "10%",
        },
        {
            title: 'Image',
            dataIndex: 'image',
            render: (label, record) =>
                record.image ? <img src={record.image} alt="notification" style={{width: 60, borderRadius: 8}}/> : "",
            width: 100,
        },
        {
            title: 'Title',
            dataIndex: 'title',
            render: (label, record) => record.title,
            width: 200,
        },
        {
            title: 'Content',
            dataIndex: 'content',
            render: (text, record) => <div dangerouslySetInnerHTML={{__html: text}}/>,
        },
        {
            title: 'Added',
            dataIndex: 'created_at',
            render: (label, record) => moment(record.created_at).format('DD-MM-YYYY H:mm:ss'),
            width: 200,
        },
        {
            title: "Action",
            key: "action",
            render: (text, record) =>
                <Space size="middle">
                    <Link to={"/notifications/" + record.id}><EditOutlined/> edit</Link>
                </Space>,
            width: 30,
        },
    ];

    const defaultPayload = {
        user_ids: [921, 192],
        sender_name: "test",
        chat_id: "15d0b740-66b4-4741-9b3e-ae7be8dc8659",
        message_id: 1,
        link: "https://app.fitlap.ee/messages?open=de20b640-188a-4e6f-8fb6-a92eb594b2e6&message=967"
    };

    const sendTestNotification = (values) => {
        Api.post('/admin/notifications/test-mentions', values)
            .then(response => {
                message.success('Test notification sent successfully!');
                console.log(response);
            })
            .catch(error => {
                message.error('Failed to send test notification');
                console.error(error);
            });
    };

    return (
        <Content style={{margin: '0 16px'}}>
            <Breadcrumb style={{margin: '16px 0'}}>
                <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
            </Breadcrumb>

            <Tabs defaultActiveKey="1">
                {/* TAB 1 - All Notifications */}
                <TabPane tab="All Notifications" key="1">
                    {loading ? (
                        <Skeleton title={true} loading={true} active/>
                    ) : (
                        <>
                            <div className="site-layout-card">
                                <Space align="center">
                                    <h1>All notifications</h1>

                                    <Button type="primary" onClick={() => redirect('/notifications/create')}>
                                        Add Notification
                                    </Button>
                                </Space>
                            </div>

                            <Alert
                                style={{margin: '10px 0'}}
                                message="Automatiseerituid teavitusi tohib muuta ainult arendajad!"
                                type="error"
                                showIcon
                            />

                            <Table
                                pagination={false}
                                columns={columns}
                                dataSource={notifications}
                                rowKey="id"
                            />
                        </>
                    )}
                </TabPane>

                {/* TAB 2 - Send Test Notification */}
                <TabPane tab="Send Test Notification" key="2">
                    <h2>Send Test Notification</h2>
                    <p>Use this to send a test notification manually with custom payload.</p>

                    <Form
                        layout="vertical"
                        form={form}
                        initialValues={defaultPayload}
                        onFinish={sendTestNotification}
                        style={{maxWidth: 600, marginTop: 20}}
                    >
                        <Form.Item
                            label="User IDs (comma separated)"
                            name="user_ids"
                            rules={[{required: true, message: 'Please enter user IDs'}]}
                        >
                            <Input placeholder="921,192" onChange={(e) => {
                                const ids = e.target.value.split(',').map(i => parseInt(i.trim())).filter(Boolean);
                                form.setFieldsValue({user_ids: ids});
                            }}/>
                        </Form.Item>

                        <Form.Item
                            label="Sender Name"
                            name="sender_name"
                            rules={[{required: true, message: 'Please enter sender name'}]}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            label="Chat ID"
                            name="chat_id"
                            rules={[{required: true, message: 'Please enter chat ID'}]}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            label="Message ID"
                            name="message_id"
                            rules={[{required: true, message: 'Please enter message ID'}]}
                        >
                            <Input type="number"/>
                        </Form.Item>

                        <Form.Item
                            label="Link"
                            name="link"
                            rules={[{required: true, message: 'Please enter a link'}]}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Send Notification
                            </Button>
                        </Form.Item>
                    </Form>
                </TabPane>
            </Tabs>
        </Content>
    );
};

export default NotificationsView;
